// DeliveryChallanReducer.js — Manufacturer Module, Phase 6, Batch 1.
// Backs Delivery Challan screens only. Wired into rootReducer.js as `deliveryChallan`.

const initialState = {
  challans: [],
  selectedChallan: null,
  remainingItems: [],
  remainingLoading: false,
  loading: false,
  actionLoading: false,
  error: null
};

const DeliveryChallanReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_DELIVERY_CHALLANS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_DELIVERY_CHALLANS_SUCCESS':
      return { ...state, loading: false, challans: action.payload, error: null };
    case 'FETCH_DELIVERY_CHALLANS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'GET_DELIVERY_CHALLAN_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_DELIVERY_CHALLAN_SUCCESS':
      return { ...state, actionLoading: false, selectedChallan: action.payload, error: null };
    case 'GET_DELIVERY_CHALLAN_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'FETCH_REMAINING_TO_DELIVER_REQUEST':
      return { ...state, remainingLoading: true, error: null };
    case 'FETCH_REMAINING_TO_DELIVER_SUCCESS':
      return { ...state, remainingLoading: false, remainingItems: action.payload, error: null };
    case 'FETCH_REMAINING_TO_DELIVER_FAILURE':
      return { ...state, remainingLoading: false, remainingItems: [], error: action.payload };

    case 'CREATE_DELIVERY_CHALLAN_REQUEST':
    case 'UPDATE_DELIVERY_CHALLAN_STATUS_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'CREATE_DELIVERY_CHALLAN_SUCCESS':
      return { ...state, actionLoading: false };

    case 'UPDATE_DELIVERY_CHALLAN_STATUS_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        challans: state.challans.map((dc) =>
          dc.id === action.payload.id ? { ...dc, status: action.payload.status } : dc
        ),
        selectedChallan:
          state.selectedChallan && state.selectedChallan.id === action.payload.id
            ? { ...state.selectedChallan, status: action.payload.status }
            : state.selectedChallan
      };

    case 'CREATE_DELIVERY_CHALLAN_FAILURE':
    case 'UPDATE_DELIVERY_CHALLAN_STATUS_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'CLEAR_SELECTED_DELIVERY_CHALLAN':
      return { ...state, selectedChallan: null };

    default:
      return state;
  }
};

export default DeliveryChallanReducer;
